import gsap from "gsap";

promokit.slide({
    el: '.event__slide',
    arrow: true,
    infinity: true,
    bullet: true
});

const intiAni = gsap.timeline({paused:true})
    .addLabel('start')
    .from(".event__bg", 7, {scale:1.5, ease:"Power1.easeOut"},"start")
    .from(".event__title", 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.5")
    .from(".event__slide", 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.7")


export default {
    id: '#event',
    name: '이벤트',
    enterStart() {
        intiAni.seek(0);
        intiAni.play();
    },
    enterEnd(){

    },
    leaveStart() {

    },
    leaveEnd(){

    }
};



// WEBPACK FOOTER //
// ./src/js/page/event.js